module.exports = __webpack_public_path__ + "static/media/nvidia.c7d98865.png";